import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

export const Overlay = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.9);
  padding: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: opacity 0.1s cubic-bezier(0.32, 0.72, 0, 1);
  opacity: ${(props) => (props.isVisible ? '1' : '0')};
  @media ${device.tablet} {
    justify-content: center;
    height: 100vh;
  }
`;

export const ModalContainer = styled.div<{ showDrawer: boolean }>`
  position: relative;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.white};
  border: 1px solid ${COLORS.white};
  overflow-y: auto;
  text-align: left;
  transition: transform 1s cubic-bezier(0.32, 0.72, 0, 1);
  transform: translateY(${(props) => (props.showDrawer ? '0' : '100%')});
  @media ${device.tablet} {
    height: auto;
    max-width: 768px;
    max-height: 50%;
    transform: unset;
    transition: all 1s cubic-bezier(0.32, 0.72, 0, 1);
    opacity: ${(props) => (props.showDrawer ? '1' : '0')};
    transform: translateY(${(props) => (props.showDrawer ? '0' : '30%')});
  }
`;

export const CloseModalButton = styled.button`
  padding: 12px;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
`;

export const CloseButtonContainer = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  justify-content: flex-end;
  background-color: ${COLORS.white};
`;
